import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CircularProgress from '@material-ui/core/CircularProgress'

const propTypes = {
  color: PropTypes.string
}

class Spinner extends Component {
  render() {
    return (
      <div className="centered">
        <div>
          <CircularProgress
            size={90}
            thickness={4}
            color={this.props.color || 'primary'}
          />
        </div>
      </div>
    )
  }
}

Spinner.propTypes = propTypes
export default Spinner



// WEBPACK FOOTER //
// ./src/components/Spinner.js